export default {
  name: "Banner",
  computed: {
    /**
     * Determine whether there is a banner image.
     */
    hasBannerImage() {
      // console.info(this.$store.state.banner && !this.$store.state.banner.class);
      return this.$store.state.banner && !this.$store.state.banner.class;
    },
  },
  methods: {
    /**
     * Get the banner class.
     */
    bannerClass() {
      let bc = "";
      if (this.hasBannerImage) {
        bc = "banner-image";
      }
      if (this.$store.state.banner.class) {
        bc = this.$store.state.banner.class;
      }
      let hc = this.heightClass();
      if (hc) {
        bc = `${bc} ${hc}`;
      }
      return bc;
    },

    /**
     * Get the height class for the banner.
     */
    heightClass() {
      if (this.$store.state.banner) {
        return `banner-${this.$store.state.banner.height}`;
      }
      return "banner-short";
    },

    /**
     * Get the background image styling for the component.
     */
    style() {
      const banner = this.$store.state.banner;
      if (this.hasBannerImage) {
        return {
          "background-image": `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/theme/banner/${banner.image}?nc=${this.$store.state.versionNumeric}')`,
        };
      }
      // return { "background-color": "#7f7f7f", color: "white" };
      return {};
    },
  },
};
